import { schema } from 'normalizr';

const aggDomains = new schema.Entity( 'aggDomains', {}, {
    idAttribute: 'domainName',
} );

export const aggDomainsSchema = [ aggDomains ];
